var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"absolute":true,"opacity":_vm.opacity,"value":_vm.value}},[_c('v-progress-linear',{staticStyle:{"min-width":"300px","max-width":"600px"},attrs:{"color":"primary","indeterminate":"","rounded":"","height":"6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }